/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'digg': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#466ca3" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M10.699 11.945h2.738v8.11h-2.738v-8.11zM10.699 8.504h2.738v2.422h-2.738V8.504zM6.767 8.504v3.441H2.835v8.11h6.671V8.504H6.768zm-1.194 9.164v-3.335h1.194v3.335H5.573zM14.631 11.945v8.11h3.932v1.06h-3.932v2.381h6.671V11.945h-6.671zm2.738 5.723v-3.335h1.194v3.335h-1.194zM22.495 11.945v8.11h3.932v1.06h-3.932v2.381h6.671V11.945h-6.671zm2.739 5.723v-3.335h1.194v3.335h-1.194z"/>'
  }
})
